import { useRouter } from "next/router";
import { useState } from "react";
import { subscribe } from "../../api-client/subscribe";

export const SubscribeForm = ({
  buttonClassName,
  inputClassName,
  rootClassName,
  buttonLabel = "Yes, I want to join!",
  group,
}: {
  buttonClassName?: string;
  inputClassName?: string;
  rootClassName?: string;
  buttonLabel?: string;
  group?: string;
}) => {
  const [email, setEmail] = useState("");
  const router = useRouter();
  const navigate = (path: string) => router.push(path);
  const r = router.query.r as string | undefined;

  return (
    <div className={rootClassName}>
      <input
        type="email"
        placeholder="Enter your email"
        className={inputClassName}
        value={email}
        onChange={(e) => setEmail(e.target.value)}
      />
      <button
        className={buttonClassName}
        onClick={() => {
          subscribe(email, navigate, { group, r });
        }}
      >
        {buttonLabel}
      </button>
    </div>
  );
};
